export default __webpack_public_path__ + "static/media/model_tutorial.57b18424.png";